import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest, all, select } from "redux-saga/effects";
// import { getUserByToken } from '../../crud/auth.crud';
import * as routerHelpers from "../../router/RouterHelpers";
import axios from "axios";
import { apiURL } from "../../../settings";
import { toast } from "react-toastify";

export const BASE_URL = process.env.REACT_APP_APIIP + "/users";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Reauth: "[Reauth] Action",
  FETCH_MFAQR: "FETCH_MFAQR",
  SET_MFAQR: "SET_MFAQR",
  SET_CONFIRMCODE: "SET_CONFIRMCODE",
  POST_CONFIRMCODE: "POST_CONFIRMCODE",
  POST_ACTIVATEMFA: "POST_ACTIVATEMFA",
  PUT_DEACTIVATEMFA: "PUT_DEACTIVATEMFA",
  PUT_DEACTIVATEMFAADMIN: "PUT_DEACTIVATEMFAADMIN",
  SET_INITAL: "SET_INITAL",
  SET_INITALTOTP: "SET_INITALTOTP",
  POST_UPDATEPASSWORD: "POST_UPDATEPASSWORD",
  SET_INITIALRECOVERY: "SET_INITIALRECOVERY",
  SET_SSOOK: "SET_SSOOK",
  SET_SSOCLEAR: "SET_SSOCLEAR",
  SET_SSOFORM: "SET_SSOFORM",
  SET_SSOFORMCLEAR: "SET_SSOFORMCLEAR",
  SET_HOSTTYPE: "SET_HOSTTYPE",
  SET_SEARCHSTRING: "SET_SEARCHSTRING",
  CLEAR_SEARCHSTRING: "CLEAR_SEARCHSTRING",
  POST_SENDEMAILMFACODE: "POST_SENDEMAILMFACODE",
  POST_CONFIRMEMAILCODE: "POST_CONFIRMEMAILCODE",
  SET_EMAILCODESENT: "SET_EMAILCODESENT",
  SET_EMAILCODE: "SET_EMAILCODE",
  SET_MFA_REMINDER_SKIPPED: "AUTH/SET_MFA_REMINDER_SKIPPED",
  SET_MFA_ACTIVATED: "SET_MFA_ACTIVATED",
};

const initialAuthState = {
  hostType: "",
  MFAQR: undefined,
  CodeAccepted: undefined,
  BckupCodes: undefined,
  emailCodeSent: false,
  emailCodeAccepted: undefined,
  user: undefined,
  authToken: undefined,
  firstName: undefined,
  surname: undefined,
  preferredName: undefined,
  refreshToken: undefined,
  roleID: undefined,
  roleDesc: undefined,
  roleScope: undefined,
  userTZ: undefined,
  winbrowserTZ: undefined,
  providertype: undefined,
  recoveryStatus: undefined,
  totp: undefined,
  forcePasswordChange: undefined,
  SSOStatus: null,
  SSOForm: null,
  SearchString: undefined,
  email: undefined,
  mfaConfigured: undefined,
  userAdmin: "No",
  mfaReminderSkipped: false,
  mfaActivated: undefined,
};

export const reducer = persistReducer(
  {
    storage,
    key: "RuralHealthConnect-Auth-2022-02-16",
    whitelist: [
      "user",
      "authToken",
      "refreshToken",
      "firstName",
      "surname",
      "preferredName",
      "roleId",
      "roleDesc",
      "roleScope",
      "userTZ",
      "winbrowserTZ",
      "providertype",
      "centreName",
      "csAgentID",
      "centralisedService",
      "Filters",
      "SearchString",
      "email",
      "mfaConfigured",
      "userAdmin",
      "mfaReminderSkipped",
    ],
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        // console.log ('In Login reducer')
        // console.log (action.payload);
        const {
          authToken,
          refreshToken,
          firstName,
          surname,
          preferredName,
          roleID,
          roleDesc,
          roleScope,
          userTZ,
          winbrowserTZ,
          totp,
          forcePasswordChange,
          providertype,
          recoveryStatus,
          centreName,
          csAgentID,
          centralisedService,
          email,
          mfaConfigured,
          userAdmin,
        } = action.payload;
        // console.log(authToken);
        // console.log(refreshToken);
        // console.log(recoveryStatus);
        // console.log(forcePasswordChange)
        return {
          ...state,
          authToken,
          refreshToken,
          firstName,
          surname,
          preferredName,
          roleID,
          roleDesc,
          roleScope,
          userTZ,
          winbrowserTZ,
          totp,
          forcePasswordChange,
          providertype,
          recoveryStatus,
          SSOStatus: true,
          centreName,
          csAgentID,
          centralisedService,
          email,
          mfaConfigured,
          userAdmin,
        };
      }

      case actionTypes.Logout: {
        routerHelpers.forgotLastLocation();
        return initialAuthState;
      }

      case actionTypes.Reauth: {
        // console.log ('In Reauth reducer')
        // console.log(action.payload);
        const { authToken, refreshToken } = action.payload;
        return { ...state, authToken, refreshToken };
      }

      case actionTypes.SET_MFAQR: {
        // console.log('In Reducer - SET_MFAQR')
        // console.log(action.payload)
        return {
          ...state,
          MFAQR: action.payload[0].qrCode,
        };
      }

      case actionTypes.CLEAR_SEARCHSTRING: {
        return {
          ...state,
          SearchString: undefined,
        };
      }

      case actionTypes.SET_SEARCHSTRING: {
        return {
          ...state,
          SearchString: action.payload,
        };
      }

      case actionTypes.SET_CONFIRMCODE: {
        return {
          ...state,
          CodeAccepted: action.payload.status,
          BackupCodes: action.payload.backupCodes,
        };
      }

      case actionTypes.SET_INITIALRECOVERY: {
        return {
          ...state,
          recoveryStatus: undefined,
        };
      }

      case actionTypes.SET_INITALTOTP: {
        return {
          ...state,
          totp: undefined,
        };
      }

      case actionTypes.SET_INITAL: {
        return {
          ...state,
          CodeAccepted: undefined,
          CodeFailed: undefined,
        };
      }

      case actionTypes.SET_SSOOK: {
        return {
          ...state,
          SSOStatus: true,
        };
      }
      case actionTypes.SET_SSOCLEAR: {
        return {
          ...state,
          SSOStatus: null,
        };
      }

      case actionTypes.SET_SSOFORM: {
        return {
          ...state,
          SSOForm: action.payload,
        };
      }

      case actionTypes.SET_SSOFORMCLEAR: {
        return {
          ...state,
          SSOForm: null,
        };
      }

      case actionTypes.SET_HOSTTYPE: {
        return {
          ...state,
          hostType: action.payload,
        };
      }

      case actionTypes.SET_EMAILCODESENT: {
        return {
          ...state,
          emailCodeSent: action.payload,
        };
      }

      case actionTypes.SET_EMAILCODE: {
        return {
          ...state,
          emailCodeAccepted: action.payload.status,
          BackupCodes: action.payload.backupCodes,
        };
      }

      case actionTypes.SET_MFA_REMINDER_SKIPPED:
        return {
          ...state,
          mfaReminderSkipped: action.payload,
        };

      case actionTypes.SET_MFA_ACTIVATED:
        return {
          ...state,
          mfaConfigured: action.payload === "Email" ? "EmailMFA" : action.payload === "Authenticator" ? "Configured" : "NotConfigured",
        };

      default:
        return state;
    }
  },
);

export function* fetchMFAQR(action) {
  try {
    const newURL = BASE_URL + "/mfa";
    // Request QR Code
    const response = yield axios.get(newURL);
    process.env.REACT_APP_DEBUG && console.log(response);
    if (response.status === 200 && response.data.returnStatus !== "Error") {
      yield put({ type: "SET_MFAQR", payload: response.data });
    } else // API completed with 200, however there is an error message
    {
      toast.error(`Action Failed: ${response.data.returnText}`);
      yield put({
        type: "PUT_ERROR",
        payload: {
          Request: action.type,
          ErrorType: `REDUX Function, ReturnCode: ${response.status}, ReturnStatus: ${response.data.returnStatus}`,
          Message: response.data.returnText,
        },
      });
    }
  } catch (
    error // API call itself has errored out
  ) {
    yield put({ type: "PUT_ERROR", payload: { Request: action.type, ErrorType: "REDUX Function, API call has errored", Message: error.message } });
  }
}

export function* postSendEmailMFACode(action) {
  try {
    const newURL = BASE_URL + "/mfaemailsend";
    const response = yield axios.post(newURL, action.payload);
    process.env.REACT_APP_DEBUG && console.log(response);
    if (response.status === 200 && response.data.returnStatus !== "Error") {
      yield put({ type: "SET_EMAILCODESENT", payload: true });
    } else // API completed with 200, however there is an error message
    {
      toast.error(`Action Failed: ${response.data.returnText}`);
      yield put({
        type: "PUT_ERROR",
        payload: {
          Request: action.type,
          ErrorType: `REDUX Function, ReturnCode: ${response.status}, ReturnStatus: ${response.data.returnStatus}`,
          Message: response.data.returnText,
        },
      });
    }
  } catch (
    error // API call itself has errored out
  ) {
    yield put({ type: "PUT_ERROR", payload: { Request: action.type, ErrorType: "REDUX Function, API call has errored", Message: error.message } });
  }
}

export function* postConfirmEmailCode(action) {
  try {
    yield put({
      type: "SET_EMAILCODE",
      payload: {
        status: undefined,
        backupCodes: undefined,
      },
    });

    const newURL = BASE_URL + "/mfaemailconfirm";

    const response = yield axios.post(newURL, action.payload);

    process.env.REACT_APP_DEBUG && console.log(response);

    if (response.status === 200 && response.data.returnStatus !== "Error") {
      yield put({
        type: "SET_EMAILCODE",
        payload: response.data,
      });
    } else {
      toast.error(`Action Failed: ${response.data.returnText}`);

      yield put({
        type: "PUT_ERROR",
        payload: {
          Request: action.type,
          ErrorType: `REDUX Function, ReturnCode: ${response.status}, ReturnStatus: ${response.data.returnStatus}`,
          Message: response.data.returnText,
        },
      });
    }
  } catch (error) {
    yield put({
      type: "PUT_ERROR",
      payload: {
        Request: action.type,
        ErrorType: "REDUX Function, API call has errored",
        Message: error.message,
      },
    });
  }
}

export function* postConfirmCode(action) {
  try {
    // Reset Parameters
    yield put({ type: "SET_INITAL" });
    // Send TOTP for validation and receive backup codes
    const newURL = BASE_URL + "/validatetotp";
    const response = yield axios.post(newURL, action.payload);
    process.env.REACT_APP_DEBUG && console.log(response);
    if (response.status === 200 && response.data.returnStatus !== "Error") {
      yield put({ type: "SET_CONFIRMCODE", payload: response.data });
    } else // API completed with 200, however there is an error message
    {
      toast.error(`Action Failed: ${response.data.returnText}`);
      yield put({
        type: "PUT_ERROR",
        payload: {
          Request: action.type,
          ErrorType: `REDUX Function, ReturnCode: ${response.status}, ReturnStatus: ${response.data.returnStatus}`,
          Message: response.data.returnText,
        },
      });
    }
  } catch (
    error // API call itself has errored out
  ) {
    yield put({ type: "PUT_ERROR", payload: { Request: action.type, ErrorType: "REDUX Function, API call has errored", Message: error.message } });
  }
}

export function* postUpdatePassword(action) {
  try {
    const newURL = BASE_URL + "/updatepassword";
    const response = yield axios.post(newURL, action.payload);
    process.env.REACT_APP_DEBUG && console.log(response);
    if (response.status === 200 && response.data.returnStatus !== "Error") {
      toast.success("Password Updated", { autoClose: 5000 });
    } else // API completed with 200, however there is an error message
    {
      toast.error("`Password Update Failed");
      yield put({
        type: "PUT_ERROR",
        payload: {
          Request: action.type,
          ErrorType: `REDUX Function, ReturnCode: ${response.status}, ReturnStatus: ${response.data.returnStatus}`,
          Message: response.data.returnText,
        },
      });
    }
  } catch (
    error // API call itself has errored out
  ) {
    yield put({ type: "PUT_ERROR", payload: { Request: action.type, ErrorType: "REDUX Function, API call has errored", Message: error.message } });
  }
}

export function* postActivateMFA(action) {
  try {
    // Get the currently logged-in user's role from Redux
    const roleDesc = yield select((state) => state.auth.roleDesc);

    // Advise that MFA should be activated
    const newURL = BASE_URL + "/activatemfa";
    const response = yield axios.post(newURL, action.payload);
    process.env.REACT_APP_DEBUG && console.log(response);
    if (response.status === 200 && response.data.returnStatus !== "Error") {
      yield put({ type: "SET_MFA_ACTIVATED", payload: action.payload.verificationMethod });
      if (roleDesc === "Admin") {
        yield put({ type: "FETCH_ADMINUSER", payload: { popCache: true } });
      } else if (roleDesc === "Psychologist") {
        yield put({ type: "FETCH_REGISTERED", payload: { popCache: true } });
      } else {
        yield put({ type: "FETCH_CSAGENT", payload: { popCache: true } });
      }
    } else // API completed with 200, however there is an error message
    {
      toast.error(`Action Failed: ${response.data.returnText}`);
      yield put({
        type: "PUT_ERROR",
        payload: {
          Request: action.type,
          ErrorType: `REDUX Function, ReturnCode: ${response.status}, ReturnStatus: ${response.data.returnStatus}`,
          Message: response.data.returnText,
        },
      });
    }
  } catch (
    error // API call itself has errored out
  ) {
    yield put({ type: "PUT_ERROR", payload: { Request: action.type, ErrorType: "REDUX Function, API call has errored", Message: error.message } });
  }
}

export function* putDeactivateMFA(action) {
  try {
    // Get the currently logged-in user's role from Redux
    const roleDesc = yield select((state) => state.auth.roleDesc);
    // Advise that MFA should be deactivated
    const newURL = BASE_URL + "/deactivatemfa";
    const response = yield axios.put(newURL);
    process.env.REACT_APP_DEBUG && console.log(response);
    if (response.status === 200 && response.data.returnStatus !== "Error") {
      if (roleDesc === "Admin") {
        yield put({ type: "FETCH_ADMINUSER", payload: { popCache: true } });
      } else if (roleDesc === "Psychologist") {
        yield put({ type: "FETCH_REGISTERED", payload: { popCache: true } });
      } else {
        yield put({ type: "FETCH_CSAGENT", payload: { popCache: true } });
      }
    } else // API completed with 200, however there is an error message
    {
      toast.error(`Action Failed: ${response.data.returnText}`);
      yield put({
        type: "PUT_ERROR",
        payload: {
          Request: action.type,
          ErrorType: `REDUX Function, ReturnCode: ${response.status}, ReturnStatus: ${response.data.returnStatus}`,
          Message: response.data.returnText,
        },
      });
    }
  } catch (
    error // API call itself has errored out
  ) {
    yield put({ type: "PUT_ERROR", payload: { Request: action.type, ErrorType: "REDUX Function, API call has errored", Message: error.message } });
  }
}

export function* putDeactivateMFAAdmin(action) {
  try {
    // Advise that MFA should be deactivated
    const newURL = BASE_URL + "/deactivatemfaadmin";
    const response = yield axios.put(newURL, action.payload);
    process.env.REACT_APP_DEBUG && console.log(response);
    if (response.status === 200 && response.data.returnStatus !== "Error") {
      if (action.payload.type === "Admin") {
        yield put({ type: "FETCH_USERS", payload: { popCache: true } });
      } else if (action.payload.type === "Psychologist") {
        yield put({ type: "FETCH_REGISTERED", payload: { popCache: true } });
      } else {
        yield put({ type: "FETCH_CSCENTRESADMIN", payload: { popCache: true } });
      }
    } else // API completed with 200, however there is an error message
    {
      toast.error(`Action Failed: ${response.data.returnText}`);
      yield put({
        type: "PUT_ERROR",
        payload: {
          Request: action.type,
          ErrorType: `REDUX Function, ReturnCode: ${response.status}, ReturnStatus: ${response.data.returnStatus}`,
          Message: response.data.returnText,
        },
      });
    }
  } catch (
    error // API call itself has errored out
  ) {
    yield put({ type: "PUT_ERROR", payload: { Request: action.type, ErrorType: "REDUX Function, API call has errored", Message: error.message } });
  }
}

export const actions = {
  login: (
    authToken,
    refreshToken,
    firstName,
    surname,
    preferredName,
    roleID,
    roleDesc,
    roleScope,
    userTZ,
    winbrowserTZ,
    totp,
    forcePasswordChange,
    providertype,
    recoveryStatus,
    centreName,
    csAgentID,
    centralisedService,
    email,
    mfaConfigured,
    userAdmin,
  ) => ({
    type: actionTypes.Login,
    payload: {
      authToken,
      refreshToken,
      firstName,
      surname,
      preferredName,
      roleID,
      roleDesc,
      roleScope,
      userTZ,
      winbrowserTZ,
      totp,
      forcePasswordChange,
      providertype,
      recoveryStatus,
      centreName,
      csAgentID,
      centralisedService,
      email,
      mfaConfigured,
      userAdmin,
    },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  reauth: (authToken, refreshToken) => ({ type: actionTypes.Reauth, payload: { authToken, refreshToken } }),
  getMFA: () => ({ type: actionTypes.FETCH_MFAQR }),
  postActivateMFA: (payload) => ({ type: actionTypes.POST_ACTIVATEMFA, payload: payload }),
  putDeactivateMFA: () => ({ type: actionTypes.PUT_DEACTIVATEMFA }),
  putDeactivateMFAAdmin: (payload) => ({ type: actionTypes.PUT_DEACTIVATEMFAADMIN, payload: payload }),
  postConfirmCode: (payload) => ({ type: actionTypes.POST_CONFIRMCODE, payload: payload }),
  updatePassword: (payload) => ({ type: actionTypes.POST_UPDATEPASSWORD, payload: payload }),
  clearMFAToken: () => ({ type: actionTypes.SET_INITALTOTP }),
  clearRecovery: () => ({ type: actionTypes.SET_INITIALRECOVERY }),
  ssook: () => ({ type: actionTypes.SET_SSOOK }),
  ssoclear: () => ({ type: actionTypes.SET_SSOCLEAR }),
  ssoform: (payload) => ({ type: actionTypes.SET_SSOFORM, payload: payload }),
  ssoformclear: () => ({ type: actionTypes.SET_SSOFORMCLEAR }),
  clearSearchString: () => ({ type: actionTypes.CLEAR_SEARCHSTRING }),
  setSearchString: (payload) => ({ type: actionTypes.SET_SEARCHSTRING, payload: payload }),
  postSendEmailMFACode: () => ({ type: actionTypes.POST_SENDEMAILMFACODE }),
  postConfirmEmailCode: (payload) => ({ type: actionTypes.POST_CONFIRMEMAILCODE, payload: payload }),
  setMfaReminderSkipped: (value) => ({ type: actionTypes.SET_MFA_REMINDER_SKIPPED, payload: value }),
};

function* actionWatcher() {
  yield takeLatest("FETCH_MFAQR", fetchMFAQR);
  yield takeLatest("POST_CONFIRMCODE", postConfirmCode);
  yield takeLatest("POST_ACTIVATEMFA", postActivateMFA);
  yield takeLatest("PUT_DEACTIVATEMFA", putDeactivateMFA);
  yield takeLatest("PUT_DEACTIVATEMFAADMIN", putDeactivateMFAAdmin);
  yield takeLatest("POST_UPDATEPASSWORD", postUpdatePassword);
  yield takeLatest("POST_CONFIRMEMAILCODE", postConfirmEmailCode);
  yield takeLatest("POST_SENDEMAILMFACODE", postSendEmailMFACode);
}

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {});
  yield all([actionWatcher()]);
}
